import styled from '@emotion/styled';

import styles from 'app/components/v2/constants/styles';

// Local Typings
export type DeviceType = 'desktop' | 'mobile';

interface ContainerProps {
  navHeight: number;
}

// Local Variables
const Wrapper = styled.div<ContainerProps>(props => ({
  left: 0,
  position: 'fixed',
  right: 0,
  top: 0,
  zIndex: styles.zIndex.nav,

  // eslint-disable-next-line sort-keys,@typescript-eslint/naming-convention
  '& + *': {
    marginTop: props.navHeight,
  },
}));

export default Wrapper;
